/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsModule
 * Purpose		: Module for CustomerDemographics.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { CustomerDemographicsService } from './CustomerDemographics.service';
import { CustomerDemographicsListComponent } from './CustomerDemographicsList.component';
import { CustomerDemographicsSearchComponent } from './CustomerDemographicsSearch.component';
import { CustomerDemographicsAddComponent } from './CustomerDemographicsAdd.component';
import { CustomerDemographicsEditComponent } from './CustomerDemographicsEdit.component';
import { CustomerDemographicsDetailsComponent } from './CustomerDemographicsDetails.component';

import { CustomerDemographicsRoutingModule } from './CustomerDemographics-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    CustomerDemographicsRoutingModule
  ],
  declarations: [
    CustomerDemographicsListComponent,
	CustomerDemographicsSearchComponent,
    CustomerDemographicsEditComponent,
    CustomerDemographicsAddComponent,
	CustomerDemographicsDetailsComponent
  ],
  providers: [
    CustomerDemographicsService
  ]
})

export class CustomerDemographicsModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerDemographics/CustomerDemographics.module.ts